import React, { useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import BaseURL from "../../BaseURL/BaseURL";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";

const RequestJoin = () => {
    const [fname,setfname] = useState();
  const [loader, setLoader] = useState(false);
    const [lname,setlname] = useState();
    const [email,setemail] = useState();
    const [type,settype] = useState();
    const [interest,setinterest] = useState();
    const navigate = useNavigate();





    const click = () =>{
    setLoader(true);
        const data = new FormData();
        data.append("fname", fname);
        data.append("lname", lname);
        data.append("email", email);
        data.append("type", type);
        data.append("interest", interest);
        try {
            var config  = {
                method: "POST",
                url: `${BaseURL.baseurl}/api/members`,
                data: data,
                headers: {
                  Accept: "application/json",
                  // Authorization: `Bearer ${token}`,
                },
              };
          axios(config)
          .then((response)=>{
            console.log(response)
          setLoader(false);
            if(response.data.status === true){
                Swal.fire({
                  title: response.data.response,
                  text: "Email Sent Successfully",
                  icon: "success",
                  dangerMode: true,
                });
                navigate('/');
              }else{
                Swal.fire({
                  title: "Something Went Wrong",
                  text: "check your Details",
                  icon: "error",
                  dangerMode: true,
                });
              }
          })
          .catch((errors)=>{
            setLoader(false);
            Swal.fire({
              title: "Something Went Wrong",
              text: errors.errors ? errors.errors[0] : "check your Details",
              icon: "error",
              dangerMode: true,
            });
          })

        } catch (errors) {
            setLoader(false);
            console.log(errors, "error");
            Swal.fire({
              title: "Something Went Wrong",
              text: errors.errors ? errors.errors[0] : "check your Details",
              icon: "error",
              dangerMode: true,
            });
        }
    }
  return (
    <>
      <Header />
      <div>
        <div class=" col-lg-8 col-md-8 ml-auto mx-auto margin_60_35">
          <div class="box_general">
            <h1 className="text-center">Request To Join</h1>
            <div>
              <div id="message-contact"></div>
              <form>
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <input
                        type="text"
                        id="email_contact"
                        name="email_contact"
                        class="form-control"
                        placeholder="First Name"
                        onChange={(e)=>setfname(e.target.value)}
                      />
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <input
                        type="text"
                        id="email_contact"
                        name="email_contact"
                        class="form-control"
                        placeholder="Last Name"
                        onChange={(e)=>setlname(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <input
                        type="text"
                        id="email_contact"
                        name="email_contact"
                        class="form-control"
                        placeholder="Email"
                        onChange={(e)=>setemail(e.target.value)}
                      />
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    {/* <div class="form-group">
                      <input
                        type="text"
                        id="email_contact"
                        name="email_contact"
                        class="form-control"
                        placeholder="Last Name"
                      />
                    </div> */}
                    <select
                      class="form-select"
                      aria-label="Default select example"
                      onChange={(e) => {
                        settype(e.target.value);
                      }}
                      style={{ opacity: 1, borderRadius: 0, }}
                    >
                      <option selected>Select Practitioner Type</option>
                      <option value="Doctor">Doctor</option>
                      <option value="Dentist">Dentist</option>
                      <option value="Hynpnotherapist">hypnotherapist</option>
                    </select>
                  </div>
                </div>
                <div class="row mt-3 mt-lg-0">
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea
                        rows="5"
                        id="message_contact"
                        name="message_contact"
                        class="form-control"
                        style={{ height: "100px" }}
                        placeholder="Describe Your Interest"
                        onChange={(e)=>setinterest(e.target.value)}
                      ></textarea>
                    </div>
                  </div>
                </div>
              </form>
              <button type="button" class="btn-theme" onClick={click}>
                {loader === true ? (
                  <TailSpin
                    height="30"
                    width="30"
                    color="#4fa94d"
                    ariaLabel="tail-spin-loading"
                    radius="1"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                ) : (
                  "Submit"
                )}
              </button>
            </div>
            {/* <!-- /col --> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RequestJoin;
